import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

/**
 * DemoAnalysisNotice
 *
 * Shown at the top of the analysis column in RecordDetailInline when the open
 * record is demo data (`record.isDemo`). Explains that the demo analysis is a
 * lightweight preview and points the user to the Upload button (top of the
 * records page) for the full, in-depth analysis of a real recording.
 *
 * Purely presentational — the CTA is text-only (references the existing Upload
 * button); it does not open the upload modal itself.
 */
export function DemoAnalysisNotice() {
  const { t } = useTranslation(['records']);

  return (
    <div
      data-testid="demo-analysis-notice"
      className={cn(
        'rounded-card border border-info bg-info-dim p-3',
        'flex items-start gap-3'
      )}
    >
      <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-info" />
      <div className="space-y-1">
        <p className="text-sm font-medium text-fg">
          {t('records.demoAnalysisNotice.title', 'Demo analysis — a simplified preview')}
        </p>
        <p className="text-xs leading-relaxed text-fg-muted">
          {t(
            'records.demoAnalysisNotice.body',
            'This is sample demo data, so the analysis here is a lightweight snapshot. Upload a real recording (the “Upload Record” button at the top) to get the full, in-depth analysis — complete transcript, detailed scoring and insights.'
          )}
        </p>
      </div>
    </div>
  );
}
